/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { SpeedLevel } from "../enums";

/** Maps each SpeedLevel to its actual playback speed multiplier. */
export type TSpeedValueMap = Record<SpeedLevel, number>;

/**
 * Maps each speed level to the actual speed multiplier used by the player.
 */
export const SPEED_VALUE: TSpeedValueMap = {
  [SpeedLevel.L1]: 3,
  [SpeedLevel.L2]: 18,
  [SpeedLevel.L3]: 60
};
